import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import { vantPlugins } from './plugins/vant'
import bridge from './utils/bridge'
import directives from './directives'
import filters from './filters'
import VConsole from 'vconsole'

// 导入样式
import 'vant/lib/index.css'
import './styles/index.scss'
import 'amfe-flexible'
import '@/styles/vant.scss'
import '@/styles/main.scss'

// 导入语言包
import zhCN from '../locale/zh.json'
import enUS from '../locale/en.json'

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

// 创建应用实例的工厂函数
export function createMyApp(App) {
  const app = createApp(App)
  const pinia = createPinia()

  // 注册全局属性
  app.config.globalProperties.$bridge = bridge
  app.config.globalProperties.$filters = filters

  // 注册全局指令
  Object.keys(directives).forEach(key => {
    app.directive(key, directives[key])
  })

  // 错误处理
  app.config.errorHandler = (err, vm, info) => {
    console.error('全局错误:', err)
    console.error('错误信息:', info)
    // 可以在这里添加错误上报逻辑
  }

  // 注册插件
  app.use(pinia)
  app.use(router)
  app.use(i18n)
  app.use(vantPlugins)

  // 移动端调试工具
  if (process.env.NODE_ENV === 'development') {
    new VConsole()
  }

  return app
}

// 创建并挂载应用
const app = createMyApp(App)
app.mount('#app')
